import { render, staticRenderFns } from "./form.vue?vue&type=template&id=87d2b522&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d2b522')) {
      api.createRecord('87d2b522', component.options)
    } else {
      api.reload('87d2b522', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=87d2b522&", function () {
      api.rerender('87d2b522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/location/form.vue"
export default component.exports